<template>
  <FeatureDetailPage feature-key="accounting" />
</template>
